var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4732 0.00823508C46.4732 0.00823508 73.7842 -1.21736 88.2639 26.2344H44.1493C44.1493 26.2344 35.8239 25.9661 28.7123 36.0659C26.6694 40.3051 24.4735 44.6719 26.9377 53.2779C23.3878 47.2638 8.09155 20.6293 8.09155 20.6293C8.09155 20.6293 18.8807 1.0935 46.4728 0.00823508H46.4732Z",
    fill: "#EF3F36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8464 69.6978C86.8464 69.6978 74.2439 93.9703 43.2427 92.7701C47.0732 86.1432 65.3062 54.5673 65.3062 54.5673C65.3062 54.5673 69.7114 47.4937 64.5146 36.2831C61.8713 32.3888 59.1771 28.3157 50.495 26.1448C57.4794 26.0814 88.1873 26.1448 88.1873 26.1448C88.1873 26.1448 99.6912 45.2593 86.8464 69.6978Z",
    fill: "#FCD900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29124 69.8893C6.29124 69.8893 -8.43069 46.8424 8.11694 20.5909C11.9348 27.2178 30.1677 58.7937 30.1677 58.7937C30.1677 58.7937 34.1005 66.1483 46.3963 67.2459C51.0825 66.9015 55.9599 66.6078 62.1912 60.1854C58.7559 66.2633 43.3443 92.8212 43.3443 92.8212C43.3443 92.8212 21.0255 93.2299 6.29088 69.8893H6.29124Z",
    fill: "#61BC5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.23 93L49.4352 67.106C49.4352 67.106 56.2535 66.5693 61.9739 60.3004C58.424 66.5443 43.23 93 43.23 93Z",
    fill: "#5AB055"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6863 46.7913C25.6863 35.3766 34.9435 26.1194 46.3581 26.1194C57.7728 26.1194 67.03 35.3766 67.03 46.7913C67.03 58.2063 57.7728 67.4631 46.3581 67.4631C34.9435 67.4504 25.6863 58.2063 25.6863 46.7913Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1462 46.7913C29.1462 37.2919 36.8457 29.5797 46.3582 29.5797C55.8576 29.5797 63.5697 37.2792 63.5697 46.7913C63.5697 56.291 55.8706 64.0032 46.3582 64.0032C36.8584 64.0032 29.1462 56.291 29.1462 46.7913Z",
    fill: "url(#paint0_linear_101_332)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1744 26.1579L62.6248 33.6528C62.6248 33.6528 58.7689 27.9963 50.4824 26.1579C57.671 26.1195 88.1744 26.1579 88.1744 26.1579Z",
    fill: "#EACA05"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4399 52.3329C22.8516 46.1147 8.09155 20.6293 8.09155 20.6293L27.0142 39.3475C27.0142 39.3475 25.0732 43.3441 25.8013 49.0641L26.4395 52.3329H26.4399Z",
    fill: "#DF3A32"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_332",
    x1: 46.3573,
    y1: 29.8227,
    x2: 46.3573,
    y2: 62.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86BBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1072BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.58ed21c06bbcdbfe88deb2008f9387b0.svg";
export { ForwardRef as ReactComponent };